import React from 'react';
import { renderToRoot } from '../../utils/render';
import { CnMessage } from './message';
import isString from 'lodash/isString';
const clsPrefix = 'cn-ui-m-message';
let hideCurrent = null;
export const hide = function () {
    if (hideCurrent) {
        hideCurrent();
    }
    hideCurrent = null;
};
export const show = function (options) {
    const { shape = 'toast', duration = 3000, content, type, onClose, ...other } = options;
    hide();
    const hideThis = renderToRoot(React.createElement("div", null,
        React.createElement(CnMessage, { visible: true, shape: shape, type: type, ...other }, content),
        React.createElement("div", { className: `${clsPrefix}-mask` })), onClose);
    hideCurrent = hideThis;
    if (duration > 0) {
        if (type === 'loading' && !('duration' in options)) {
            return hideThis;
        }
        setTimeout(() => {
            hideThis();
            if (hideCurrent === hideThis) {
                hideCurrent = null;
            }
        }, duration);
    }
    return hideThis;
};
const handleFastCall = (type, options) => {
    let opts;
    if (isString(options)) {
        opts = {
            title: options,
        };
    }
    else {
        opts = options;
    }
    return show({
        ...opts,
        type,
    });
};
export const success = handleFastCall.bind(null, 'success');
export const error = handleFastCall.bind(null, 'error');
export const notice = handleFastCall.bind(null, 'notice');
export const warning = handleFastCall.bind(null, 'warning');
export const help = handleFastCall.bind(null, 'help');
export const loading = handleFastCall.bind(null, 'loading');
